module.exports = __webpack_public_path__ + "static/media/complex.217bd781.svg";